/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Card_Sold_OutInputs */

const en_card_sold_out = /** @type {(inputs: Card_Sold_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold out`)
};

/**
* | output |
* | --- |
* | "Sold out" |
*
* @param {Card_Sold_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const card_sold_out = /** @type {((inputs?: Card_Sold_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_Sold_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_card_sold_out(inputs)
});